<template>
  <div id="stufocus">
    <!-- {{stufocusList}} -->
    <small class="color-gray">工作任务数据需要在考务系统PC端处理</small>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stufocusList: []
    };
  },
  methods: {},
  created() {
    /* this.apiStufocusListGet(
      {
        WorkID: this.getWork().WorkID
      },
      this,
      res => {
        this.stufocusList = res;
      }
    ); */
  }
};
</script>

<style scoped>
</style>